export interface IDistance {
  from: number;
  to: number;
  price: number;
}

export const isOverlapping = (d1: IDistance, d2: IDistance): boolean => {
  return (
    (d1.from >= d2.from && d1.from <= d2.to) ||
    (d1.to >= d2.from && d1.to <= d2.to)
  );
};
